import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

/** Gates reading Skills and Rules, wherever they are shown. */
export const canReadAgentInstructions = defineAbilityConfig({
  abilities: {isAIToggleEnabled: true},
  permission: ['read', 'siteAgentInstructions'],
  userTypes: {
    authorizedInDesigner: true,
    unauthorized: false,
  },
  branches: {
    main: true,
  },
  siteModes: {design: true, edit: true},
  featureFlags: {
    [FEATURE_FLAGS.AGENT_INSTRUCTIONS]: true,
  },
} as const);

/** Gates the Designer surface for viewing Skills and Rules. */
export const canAccessInstructionsPanel = defineAbilityConfig({
  abilities: {canReadAgentInstructions: true},
  workflows: {
    canvas: true,
    logicFlows: true,
    dynamicData: true,
    preview: true,
    comment: true,
    optimization: true,
    analyzeVisualView: true,
    webApps: true,
    agents: true,
    // Campaign sites boot into the Campaigns Home surface; without this the
    // Instructions icon in the campaign rail (CAM-867) only appears after
    // entering a campaign page (canvas workflow).
    campaignsHome: true,
  },
} as const);

/** Gates mutation controls for Skills and Rules. */
export const canManageInstructionsPanel = defineAbilityConfig({
  abilities: {canAccessInstructionsPanel: true},
  permission: ['manage', 'siteAgentInstructions'],
} as const);
